export const Constant = {
  DEFAULT_DURATION_IN_MS: 500,
  DEFAULT_DELAY_IN_MS: 0,

  INITIAL_ROTATION_Z_IN_RADIAN: -Math.PI / 2,
  FINAL_ROTATION_Z_IN_RADIAN: 0,

  INITIAL_POSITION_X: -200,
  FINAL_POSITION_X: 0,
};
